import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=03bef4a3&scoped=true&"
import script from "./cost.vue?vue&type=script&lang=js&"
export * from "./cost.vue?vue&type=script&lang=js&"
import style0 from "./cost.vue?vue&type=style&index=0&id=03bef4a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bef4a3",
  null
  
)

export default component.exports